import { useIntersectionObserver } from "@vueuse/core";
import { watch } from "vue";

import type { ComputedRef, MaybeRefOrGetter, Ref } from "vue";

interface UseInfiniteScrollSentinelOptions {
  sentinel: Ref<HTMLElement | null>;
  canLoadMore: Ref<boolean> | ComputedRef<boolean>;
  isLoading: Ref<boolean> | ComputedRef<boolean>;
  onLoadMore: () => void | Promise<void>;
  root?: MaybeRefOrGetter<HTMLElement | null>;
  rootMargin?: string;
}

const useInfiniteScrollSentinel = ({
  sentinel,
  canLoadMore,
  isLoading,
  onLoadMore,
  root,
  rootMargin = "50px",
}: UseInfiniteScrollSentinelOptions) => {
  const { pause, resume } = useIntersectionObserver(
    sentinel,
    async ([entry]) => {
      if (entry?.isIntersecting && canLoadMore.value && !isLoading.value) {
        await onLoadMore();
      }
    },
    {
      root,
      rootMargin: `0px 0px ${rootMargin} 0px`,
      threshold: 0,
    }
  );

  watch(
    canLoadMore,
    (value) => {
      if (value) {
        resume();
      } else {
        pause();
      }
    },
    { immediate: true }
  );
};

export { useInfiniteScrollSentinel };
